import { Calendar } from "components/calendar";
import { TITLE } from "@/modules/timesheet/logs/views/calendar/constants";
import TimeSheetLogLayout from "@/modules/timesheet/logs/layout";
import TimesheetDayCell from "./_Cell";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import useMonthlyTimesheet from "./useMonthlyTimesheet";
import { useState } from "react";

export default function TimesheetLogCalendar() {
  const [date, setDate] = useState(new Date());
  const { transformedData, isLoading } = useMonthlyTimesheet(date);

  return (
    <TimeSheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      <Calendar
        key={transformedData.id}
        date={date}
        setDate={setDate}
        events={transformedData}
        renderDay={TimesheetDayCell}
        isLoading={isLoading}
        isHeaderPortal={true}
      />
    </TimeSheetLogLayout>
  );
}
